/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const stylesRoot = css`
  align-self: start;
  background: ${Colors.Blue2};
  display: inline-block;
  padding: 1px 8px;
  font-weight: 700;
  border-radius: 10px;
`;

const Badge = ({ children }) => {
  return <span css={stylesRoot}>{children}</span>;
};

export default Badge;
